"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentMethodFactor = exports.PaymentMethods = exports.PaymentMethod = void 0;
const payment_period_1 = require("./payment-period");
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CreditCard"] = "Credit Card";
    PaymentMethod["ACH"] = "ACH";
    PaymentMethod["Direct"] = "Direct";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
exports.PaymentMethods = Object.values(PaymentMethod);
function getPaymentMethodFactor(paymentMethod, paymentPeriod) {
    const BASE_PAYMENT_FACTOR = 1;
    const INCREASED_PAYMENT_FACTOR = 1.05;
    if (paymentPeriod === payment_period_1.PaymentPeriod.Annually) {
        return BASE_PAYMENT_FACTOR;
    }
    if (paymentMethod === PaymentMethod.ACH) {
        return BASE_PAYMENT_FACTOR;
    }
    return INCREASED_PAYMENT_FACTOR;
}
exports.getPaymentMethodFactor = getPaymentMethodFactor;
//# sourceMappingURL=payment-method.js.map